import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { API_URL } from '../../lib/utils';
import { FormCard } from './LegalFormsDatabase';
import { Button } from '../../components/ui/button';
import { Bookmark, MapPin, ScrollText } from 'lucide-react';

const MyLegalForms = () => {
  const [forms, setForms] = useState([]);
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await axios.get(`${API_URL}/legal-forms/saved/list`);
      setForms(r.data.forms || []); setStates(r.data.saved_states || []);
    } catch (e) { setForms([]); } finally { setLoading(false); }
  }, []);
  useEffect(() => { document.title = 'My Saved Legal Forms | I Need A Social Worker'; load(); }, [load]);

  const saveToggle = async (formId) => {
    await axios.post(`${API_URL}/legal-forms/save`, { form_id: formId });
    toast.success('Removed from saved.'); load();
  };

  return (
    <div className="min-h-screen bg-[#F7F5EF] pt-24 pb-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <h1 className="font-serif text-3xl font-bold text-primary flex items-center gap-2"><Bookmark className="w-6 h-6 text-secondary" /> My Saved Legal Forms</h1>
          <Link to="/advance-directives"><Button variant="outline" data-testid="browse-more-forms">Browse the database</Button></Link>
        </div>

        {states.length > 0 && (
          <div className="mt-5">
            <p className="text-sm font-semibold text-gray-600 mb-2">Saved states</p>
            <div className="flex flex-wrap gap-2">
              {states.map((s) => <Link key={s.slug} to={`/advance-directives/${s.slug}`} className="px-3 py-1.5 rounded-full bg-white border text-sm text-gray-700 hover:border-secondary flex items-center gap-1"><MapPin className="w-3 h-3" /> {s.name}</Link>)}
            </div>
          </div>
        )}

        <div className="mt-6">
          {loading ? <p className="text-gray-500">Loading…</p> : forms.length === 0 ? (
            <div className="bg-white rounded-xl border p-10 text-center">
              <ScrollText className="w-10 h-10 text-gray-300 mx-auto mb-2" />
              <p className="text-gray-600 font-medium">You haven't saved any forms yet.</p>
              <Link to="/advance-directives"><Button className="mt-3 bg-secondary hover:bg-secondary-hover text-white">Find official forms</Button></Link>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
              {forms.map((f) => <FormCard key={f.form_id} f={{ ...f, category_label: f.category_label }} onSaveToggle={saveToggle} saved />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyLegalForms;
